import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseVariant7 = lazyWithPreload(
  () => import('./PurchaseVariant7'),
)
